
import React, { Component } from 'react';
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';
import './LiveChat.scss';
import OOHImg from '../../assets/images/chat_ooh.svg';
import CloseImg from '../../assets/images/closeChatButton.svg';

/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */
/** @import {OohButtonProps, OohButtonState, OohTextProps, OohTextState} from './OutOfHoursTypes' */

/** @extends {Component<OohTextProps, OohTextState>} */
class OohText extends Component {
    state = {
        showing: false
    };

    onClickSubmitButton = () =>
        this.props.onCh();
    

    render() {
        const showHolidaysMessage = this.props.featureEnabled("EnableHolidaysOutofHourMessage");
        const message = showHolidaysMessage 
            ? "We're currently offline. We'll be closing live chat at 16:00 on Christmas Eve and New Year's Eve. Our usual chat hours are 08:00-20:00 Monday to Friday, excluding bank holidays."
            : "We're currently offline. You can chat with one of our live chat agents from 08:00-20:00 Monday to Friday, excluding bank holidays.";

        return (
            <div className='ChatInfo'>
                <div className='ChatInfo__Header'>
                    <img src={OOHImg} className='' />
                    <div className='ChatInfo__Title'>Live Chat</div>
                    <div className='ChatInfo__Close' onClick={() => this.onClickSubmitButton()}><img src={CloseImg} className='' /></div>
                </div>
                <div className='ChatInfo__ChatContent'>
                    <p>{message}</p>
                </div>
            </div>
        );
    }
}

/** @extends {Component<OohButtonProps, OohButtonState>} */
class OohButton extends Component {
    state = {
        chatVisible: false,
        chatTextVisible: true
    };

    onClickButton = () => 
        this.setState(prevState => ({
            chatVisible: !prevState.chatVisible,
            chatTextVisible: !prevState.chatTextVisible
        }));

    changedChat = () => 
        this.onClickButton();
    

    render() {
        return (
            <section className='LiveChat'>
                <div className='LiveChat__wrapper' onClick={() => this.onClickButton()}
                    style={this.state.chatVisible ? { display: "none" } : { display: "flex" }}  >
                    <div className='chat__chaticon-container'>
                        <img src={OOHImg} className='' />
                    </div>
                    <div className='chat__chatbutton-title'>
                        <div className="chat-t1" aria-label="Live chat">Live chat</div>
                        <div className="chat-t2" aria-label="Need help?">We're offline</div>
                    </div>
                </div>
                {this.state.chatVisible ? <OohText onCh={this.changedChat} featureEnabled={this.props.featureEnabled} /> : null}
            </section>

        );
    }
}

/** @extends {Component<WithFeatureFlagsProps>} */
class OohChatBox extends Component {
    render() {
        if (this.props.featureEnabled("OutOfHoursChat")) {
            return <OohButton featureEnabled={this.props.featureEnabled} />;
        }
        return null;
    }
}

export default withFeatureFlags(OohChatBox);


